import React from 'react';
import './DateTimePicker.scss';
import { ReactComponent as CalendarIcon } from 'assets/icons/calendar.svg';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import { Box } from '@mui/material';

function DateTime(props) {
	const [value, setValue] = React.useState(new Date());

	const baseTheme = createTheme();
	const newTheme = (theme) =>
		createTheme({
			...theme,
			components: {
				MuiPickersToolbar: {
					styleOverrides: {
						root: {
							color: '#ad1457',
							borderRadius: '2px',
							borderWidth: '1px',
							borderColor: '#e91e63',
							border: '1px solid',
							backgroundColor: '#f48fb1',
						},
					},
				},
			},
		});
	const handleDateChange = (date) => {
		if (date && dayjs.isDayjs(date)) {
			if (props.showTime) {
				props.onChange(date.valueOf());
			} else {
				props.onChange(date.startOf('day').valueOf());
			}
		}
	};

	// Create a simple input component
	const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
		<div className="dtp-input" onClick={onClick}>
			<input value={value} readOnly ref={ref} className={props.withBackground ? 'withBack' : ''} />
			<CalendarIcon />
		</div>
	));

	return (
		<div className="DateTimePicker">
			{/* <LocalizationProvider dateAdapter={AdapterDayjs}>
				helloooo
				<DesktopDatePicker
					label="Custom input"
					value={value}
					onChange={(newValue) => {
						setValue(newValue);
					}}
					renderInput={({ inputRef, inputProps, InputProps }) => (
						<Box sx={{ display: 'flex', alignItems: 'center' }}>
							<input ref={inputRef} {...inputProps} />
							{InputProps?.endAdornment}
						</Box>
					)}
				/>
			</LocalizationProvider> */}

			<LocalizationProvider dateAdapter={AdapterDayjs}>
				<ThemeProvider theme={newTheme(baseTheme)}>
					{props.showTime ? (
						<DateTimePicker
							value={props.value ? dayjs(props.value) : null}
							onChange={handleDateChange}
							components={{
								OpenPickerIcon: CalendarIcon,
							}}
							renderInput={(params) => <CustomInput {...params} />}
							inputFormat="DD MMM YYYY h:mm A"
							maxDate={props.disableToday ? dayjs().subtract(1, 'day') : undefined}
							disableFuture
						/>
					) : (
						<DatePicker
							value={props.value ? dayjs(props.value) : null}
							onChange={handleDateChange}
							components={{
								OpenPickerIcon: CalendarIcon,
							}}
							inputFormat="DD MMM YYYY"
							maxDate={props.disableToday ? dayjs().subtract(1, 'day') : undefined}
							disableFuture
							label={props.label}
							size="small"
						/>
					)}
				</ThemeProvider>
			</LocalizationProvider>
		</div>
	);
}

export default DateTime;
